var PageOrderCheckout = (function ($) {

    PageOrderCheckout = function (options) {
        var that = this;

        that.class = {
            variant: 'js-variant',
            variant_route: 'js-variant-route',
            variant_direction_departure: 'js-variant-direction-departure',
            variant_direction_arrival: 'js-variant-direction-arrival',
            variant_localtime_disclaimer: 'js-drawer-localtime-disclaimer',
            variant_duration: 'js-duration',

            variant_segments_wrapper: 'js-segments-wrapper',
            fareremark_info: 'js-fareremark-info',

            drawer_segments_trigger: 'js-drawer-segments-trigger',

            passenger_row: 'js-passenger-row',
            passenger_name: 'js-passenger-name',
            passenger_edit: 'js-passenger-edit',

            payment_selected: 'js-payment-selected',
            confirm_terms: 'js-confirm-terms',

            timelimit: 'js-timelimit',

            hidden: 'is-hidden',
            loading: 'loading',
            closed: 'closed',

            confirm_terms_tooltip_warning: 'js-confirm-terms-tooltip-warning',
            confirm_terms_tooltip_warning_checkbox: 'js-confirm-terms-tooltip-warning-checkbox',
            tooltip_warning_checkbox_error: 'error',

            input_email: 'js-email',
            input_phone: 'js-phone',
            flow_panel: 'flow-panel',
            toggle_wrapper: 'js-toggle-wrapper',
            toggle_trigger_open: 'js-toggle-trigger-open',
            toggle_trigger_close: 'js-toggle-trigger-close',

            payment_discount_wrapper: 'js-payment-discount-wrapper',
            payment_discount: 'js-payment-discount',
            payment_promocode: 'js-payment-promocode',
            payment_promocode_discount: 'js-payment-promocode-discount',
            payment_total_amount: 'js-total-amount',

            payment_instances_wrapper: 'js-payment-instances-wrapper',
            payment_instances_all_button: 'js-payment-instances-all-button',
            payment_instances_all_button_wrapper: 'js-payment-instances-all-button-wrapper',
            payment_instance: 'js-payment-instance'
        }

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$flow_panel = that.$wrapper.find('.' + that.class.flow_panel);
        that.$steps = that.$wrapper.find('.js-steps');
        that.$order_content = that.$wrapper.find('.js-order-content');
        that.$order_sidebar = that.$wrapper.find('.js-order-sidebar');
        that.$order_frame = that.$wrapper.find('.js-order-frame');

        that.$proceed_payment = that.$wrapper.find('.js-proceed-payment');

        // Confirm terms
        that.$confirm_terms_checkbox = that.$wrapper.find('.' + that.class.confirm_terms);
        that.$confirm_terms_tooltip = that.$wrapper.find('.' + that.class.confirm_terms_tooltip_warning);
        that.$confirm_terms_tooltip_checkbox = that.$wrapper.find('.' + that.class.confirm_terms_tooltip_warning_checkbox);

        // Promocode
        that.$promocode_mobile_button = that.$wrapper.find('.js-promocode-mobile-button');

        that.payment_instances_default_count_limit = options['payment_instances_default_count_limit'];

        // CONST
        that.is_payment_items_exist = options['is_payment_items_exist'];

        that.order_hash = options['order_hash'];
        that.order_passenger_hash = options['order_passenger_hash'];
        that.order_url = options['order_url'];
        that.order_checkout_result_urls = options['order_checkout_result_urls'];

        that.timelimit = options['timelimit'];
        that.storefront_id = options['storefront_id'];
        that.order_payment_hash = options['order_payment_hash'];

        that.order_contact_data = {};

        that.locales = options['locales'];
        that.urls = options['urls'];
        that.modals = options['modals'];
        that.is_show_order_contact_data_modal = options['is_show_order_contact_data_modal'];

        that.PROMOCODE_STATUS = {
            ok: 'ok',
            fail: 'fail'
        };
        // DYNAMIC VARS
        that.is_locked = false;
        that.order_contact_data_form = null;
        // Analytics data
        that.analytics_data = options.analytics_data || null;
        that.analytics_select_content_id = {
            main: {payment: 'main_payment', processing: 'main_processing'},
            add: {payment: 'svc_add_payment', processing: 'svc_add_processing'}
        };

        // Flocktory data
        that.flocktory_data = options.flocktory_data || null;

        // Promocodes
        that.promocode_section = that.__initPromocodeSection();
        that.promocode_apply_promise = null;
        that.promocode_cancel_promise = null;

        // INIT
        that.init();
    };

    PageOrderCheckout.prototype.init = function () {
        var that = this;

        //
        that.initVariants();
        //
        that.initPassengerEdit();
        //
        that.__initTimelimit();
        //
        that.__initConfirmTerms();
        //
        that.__initProceedPaymentButton();
        //
        that.__initFareremark();
        //
        that.initOrderWillBeCanceledModal();
        //
        that.initFlowPanelMobileToggleEvents();
        //
        that.__sendBeginCheckoutAnalyticsEvent();
        //
        that.__initPaymentInstancesAllButtonHandler();
    };

    PageOrderCheckout.prototype.initVariants = function () {
        var that = this,
            $variants = that.$wrapper.find('.' + that.class.variant);

        $.each($variants, function (i, checkout_variant) {
            var $variant = $(checkout_variant);

            that.checkoutVariant($variant);
        });
    };

    PageOrderCheckout.prototype.checkoutVariant = function ($variant) {
        var that = this;

        $variant.on('click', '.' + that.class.drawer_segments_trigger, function (e) {
            e.preventDefault();
            that.__drawerSegmentsCall($(this));
        });
    };

    PageOrderCheckout.prototype.__initFareremark = function () {
        var that = this;

        that.$wrapper.on('click', '.' + that.class.fareremark_info, function () {
            $.sa.analytics.reachGoal('fareremark', {source: 'order_checkout'});

            $.uiFareremark({
                order_hash: that.order_hash,
                order_passenger_hash: that.order_passenger_hash
            });
        });
    };

    PageOrderCheckout.prototype.__drawerSegmentsCall = function (trigger) {
        var that = this,
            $trigger = $(trigger),
            $variant = $trigger.parents('.' + that.class.variant),

            drawer_header = [
                $variant.find('.' + that.class.variant_direction_departure).text(),
                $variant.find('.' + that.class.variant_direction_arrival).text()
            ],
            variant_duration = [
                $variant.find('.' + that.class.variant_duration).data('travel-time'),
                $variant.find('.' + that.class.variant_duration).text()
            ],
            $drawer_content = $variant.find('.' + that.class.variant_segments_wrapper).clone();

        $drawer_content.append($variant.find('.' + that.class.variant_localtime_disclaimer).html());

        $.uiDrawer({
            position: 'right',
            custom_class: 'narrow variant-card no-radius drawer-segments',
            header_title: drawer_header.join(' — '),
            header_description: variant_duration.join(': '),
            content: $drawer_content.html()
        });
    };

    PageOrderCheckout.prototype.initPassengerEdit = function () {
        var that = this,
            $row = that.$wrapper.find('.' + that.class.passenger_row);

        $row.on('click', '.' + that.class.passenger_edit, function (e) {
            e.preventDefault();
            that.__modalEditPassengerCall($(this));
        });
    };

    PageOrderCheckout.prototype.__modalEditPassengerCall = function (trigger) {
        var that = this,
            $trigger = $(trigger),
            $passenger = $trigger.parents('.' + that.class.passenger_row),
            passenger_name = $passenger.find('.' + that.class.passenger_name).text().trim(),
            modal_content = `Вы собираетесь изменить данные пассажира <strong>${passenger_name}</strong>. <br>`;

        $.uiModal({
            header_title: 'Смена данных пассажира',
            content: modal_content,
            button_confirm_text: 'Да, меняю данные',
            button_cancel_text: 'Передумал менять данные'
        });
    };

    PageOrderCheckout.prototype.__initTimelimit = function () {
        var that = this,
            $timelimit = that.$wrapper.find('.' + that.class.timelimit),
            modal_title = $timelimit.data('expired-title'),
            modal_description = $timelimit.data('expired-description'),
            modal_link_url = $timelimit.data('expired-link-url'),
            modal_link_text = $timelimit.data('expired-link-text'),
            modal_icons = $timelimit.data('expired-icons');

        new UITimelimit({
            $wrapper: $timelimit,
            timelimit: that.timelimit,
            onTimeLeft: function () {
                if (typeof that.analytics_data === 'object') {
                    var selected_payment = that.$wrapper.find(`.${that.class.payment_selected}`).val();
                    $.sa.analytics.gtag('event', 'remove_from_cart', Object.assign({}, that.analytics_data, {payment_type: selected_payment}));
                }

                if (that.order_contact_data_form && that.order_contact_data_form.order_contact_data_modal) {
                    that.order_contact_data_form.order_contact_data_modal.close();
                }

                $.uiModal({
                    header_icons: modal_icons,
                    header_title: modal_title,
                    custom_class: 'align-center',
                    remove_close_cross: true,
                    esc: false,
                    onBgClick: function (modal, event) {
                        event.preventDefault();
                        return false;
                    },
                    content: `${modal_description} <br><br> <a class="button large primary js-disable-router" href="${modal_link_url}">${modal_link_text}</a>`
                });
            }
        });
    };

    PageOrderCheckout.prototype.__toggleConfirmTermsTooltip = function (state) {
        var that = this;

        if (state === 'show') {
            that.$confirm_terms_tooltip.css('opacity', '1');
            that.$confirm_terms_tooltip_checkbox.addClass(that.class.tooltip_warning_checkbox_error);
        }

        if (state === 'hide') {
            that.$confirm_terms_tooltip.removeAttr('style');
            that.$confirm_terms_tooltip_checkbox.removeClass(that.class.tooltip_warning_checkbox_error);
        }
    };

    PageOrderCheckout.prototype.__initConfirmTerms = function () {
        var that = this;

        that.$confirm_terms_checkbox.on('change', function () {
            var checked = $(this).prop('checked');
            if (checked) {
                that.__toggleConfirmTermsTooltip('hide');
            }

            that.$confirm_terms_checkbox.prop('checked', checked);
        });
    };

    PageOrderCheckout.prototype.__initProceedPaymentButton = function () {
        var that = this;

        that.$proceed_payment.on('click', function (e) {
            if (!that.$confirm_terms_checkbox.prop('checked')) {
                that.__toggleConfirmTermsTooltip('show');
                return false;
            }

            if (that.is_show_order_contact_data_modal && $.isEmptyObject(that.order_contact_data)) {
                that.__showOrderContactDataModal();
                return false;
            }

            that.__initProceedPayment();
        });
    }

    PageOrderCheckout.prototype.__initProceedPayment = function () {
        var that = this,
            href = $.sa.build_url('order/checkout/payment');

        if (!that.is_payment_items_exist) {
            $.uiModal({
                mobile_fullscreen: false,
                $wrapper: $(that.modals['not_payment_items']).clone(),
                disable_content_scroll: true,
            });
            return;
        }

        if (that.is_locked) {
            return;
        }

        that.is_locked = true;

        var data = {
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            payment_instance_id: that.$wrapper.find('.' + that.class.payment_selected + ':checked').val(),
            order_payment_hash: that.order_payment_hash,
            storefront_id: that.storefront_id,
            payment_email: that.order_contact_data.email || null,
            payment_phone: that.order_contact_data.phone || null,
            color_scheme: $.sa.is_dark_theme() ? 'dark' : 'light'
        };

        $.sa.buttonLoading(that.$proceed_payment, true);

        $.post(href, data, function (res) {
            if (!res) {
                res = {
                    status: 'fail',
                    errors: [
                        {
                            code: 0,
                            message: $.sa.locales['something_went_wrong'],
                        }
                    ],
                };
            }

            switch (res.status) {
                case 'ok':
                    that.__handleProceedPaymentSuccess(res);
                    break;
                case 'fail':
                    that.__handleProceedPaymentError(res);
                    break;
            }

            that.is_locked = false;
            $.sa.buttonLoading(that.$proceed_payment, false);
        });
    };

    //
    // Promocode
    //

    PageOrderCheckout.prototype.__propControlsLoadingState = function (is_loading) {
        var that = this;
        $.sa.buttonLoading(that.$proceed_payment, !!is_loading);

        if (that.$promocode_mobile_button.length) {
            $.sa.buttonLoading(that.$promocode_mobile_button, !!is_loading);
        }
    }

    PageOrderCheckout.prototype.__initPromocodeSection = function() {
        var that = this;

        const selectors = {
            section: '.js-promocode-section'
        }

        // DOM
        const $promocode_wrapper = that.$wrapper.find('.js-promocode-wrapper'),
              $promocode_section = $promocode_wrapper.find(selectors.section);

        const modal_class = 'order-checkout-promocode-modal';

        let promocode_section = null;

        if ($promocode_section.length) {
            promocode_section = new OrderCheckoutPromocodeSection($promocode_section, {
                order_checkout: that
            });

            that.$promocode_mobile_button.on('click', function(event) {
                event.preventDefault();

                // Если запросы в процессе выполнения блокируем открытие дровера
                if (that.promocode_cancel_promise || that.promocode_apply_promise) { return false; }

                showMobileForm(promocode_section);
            });
        }

        return promocode_section;

        //

        /**
         * @param {OrderCheckoutPromocodeSection} promocode_section
         * */
        function showMobileForm(promocode_section) {
            const { promocode: header } = that.locales;
            const { $section } = promocode_section;

            const html = $section[0].outerHTML;

            $.uiDrawerBottom({
                header_contrast: true,
                header: header,
                content: html,
                onOpen: function($wrapper, drawer) {
                    const $section = $wrapper.find(selectors.section);

                    const modal_promocode_section = new OrderCheckoutPromocodeSection($section, {
                        order_checkout: that,
                        onApplyCode: function(code) {
                            promocode_section.renderCode(code);
                            drawer.close();
                        },
                        onCancelCode: function() {
                            promocode_section.clear();
                            drawer.close();
                        }
                    });

                    $wrapper.addClass(modal_class)
                        .find('.button').addClass('large');
                },
                onBgClick: function (uiDrawerBottom) {
                    uiDrawerBottom.close();
                }
            });
        }
    };

    /**
     * @param {String} promocode
     * @return {jQuery.Deferred}
     * */
    PageOrderCheckout.prototype.cancelPromocode = function(promocode) {
        const that = this;

        if (that.promocode_cancel_promise) { return that.promocode_cancel_promise; }

        const deferred = $.Deferred();

        // Preparing for the request
        that.__propControlsLoadingState(true);

        var href = $.sa.build_url('order/' + that.order_hash + '/checkout/promocode/cancel'),
            data = {
                promocode: promocode,
                order_payment_hash: that.order_payment_hash
            };

        // Request
        $.post(href, data, 'json')
            .done( function(res) {
                if (res && res.status && res.status === 'ok') {
                    that.__promocodeDiscountRender(res.data);
                    that.__actualizeAvailablePaymentInstancesList(res?.data?.payment_instances ?? undefined);
                    deferred.resolve();
                } else {
                    $.sa.notifier.show({
                        title: res.errors?.[0]?.message ?? $.sa.locales['try_again_later'],
                        notifier_class: $.sa.notifier.class.error
                    });
                    deferred.reject();
                }
            })
            .fail( function() {
                $.sa.notifier.show({
                    title: $.sa.locales['try_again_later'],
                    notifier_class: $.sa.notifier.class.error,
                });
                $.sa.error('Promocode $.post failed. See PageOrderCheckout.prototype.cancelPromocode()');
                deferred.reject();
            })
            .always( function() {
                that.__propControlsLoadingState(false);
                that.promocode_cancel_promise = null;
            });

        that.promocode_cancel_promise = deferred.promise();
        return that.promocode_cancel_promise;
    }

    /**
     * @param {String} promocode
     * @return {jQuery.Deferred}
     * */
    PageOrderCheckout.prototype.usePromocode = function(promocode) {
        const that = this;

        if (that.promocode_apply_promise) { return that.promocode_apply_promise; }

        const deferred = $.Deferred();

        // Preparing for the request
        that.__propControlsLoadingState(true);

        var href = $.sa.build_url('order/' + that.order_hash + '/checkout/promocode/apply'),
            data = {
                promocode: promocode,
                order_payment_hash: that.order_payment_hash
            };

        // Request
        $.post(href, data, 'json')
            .done( function(res) {
                if (res && res.status && res.status === 'ok') {
                    that.__promocodeDiscountRender(res.data);
                    that.__actualizeAvailablePaymentInstancesList(res?.data?.payment_instances ?? undefined);
                    deferred.resolve();
                } else {
                    onFail(res);
                }
            })
            .fail( function() {
                $.sa.notifier.show({
                    title: $.sa.locales['try_again_later'],
                    notifier_class: $.sa.notifier.class.error,
                });
                $.sa.error('Promocode $.post failed. See PageOrderCheckout.prototype.usePromocode()');
                deferred.reject();
            })
            .always( function() {
                that.__propControlsLoadingState(false);
                that.promocode_apply_promise = null;
            });

        that.promocode_apply_promise = deferred.promise();
        return that.promocode_apply_promise;

        //

        function onFail(res) {
            const result = {};

            var error = res.errors?.[0] ?? null;
            if (error) {
                if (error.code === 42001) {
                    result.clear = true;
                    // Promo code requires Smart Up
                    $.uiModal({
                        html: that.modals['promocode_requires_smartup']
                    });
                } else {
                    result.message = error.message || '';
                }
            }

            deferred.reject(result);
        }
    }

    PageOrderCheckout.prototype.__promocodeDiscountRender = function (data) {
        var that = this,
            order_payment = data['order_payment'],
            order_promocode = data['promocode'],
            $payment_discount_wrapper = that.$order_sidebar.find('.' + that.class.payment_discount_wrapper),
            $payment_discount = $payment_discount_wrapper.find('.' + that.class.payment_discount),
            $payment_promocode_discount = $payment_discount_wrapper.find('.' + that.class.payment_promocode_discount),
            $payment_total_amount = that.$wrapper.find('.' + that.class.payment_total_amount),
            $payment_promocode = that.$order_sidebar.find('.' + that.class.payment_promocode);

        if (order_payment['discount'] > 0) {
            $payment_discount_wrapper.show()
        } else {
            $payment_discount_wrapper.hide();
        }

        $payment_discount.text('- ' + order_payment['discount_formatted']);
        $payment_promocode_discount.text('- ' + order_payment['discount_formatted']);
        $payment_total_amount.text(order_payment['total_with_discount_formatted']);
        $payment_promocode.text(order_promocode['code']);
    }

    //
    //
    //
    //
    //

    PageOrderCheckout.prototype.__handleProceedPaymentSuccess = function (res) {
        var that = this;

        //
        that.order_payment_hash = res.data['order_payment_hash'];
        that.initPaymentStatusChecker();
        that.constructEventListener();

        //
        that.togglePaymentFrame();
        that.$order_frame.html(res.data['order_payment_data']);

        //
        if (typeof that.analytics_data === 'object') {
            var selected_payment = that.$wrapper.find(`.${that.class.payment_selected}`).val();
            $.sa.analytics.gtag('event', 'add_payment_info', Object.assign({}, that.analytics_data, {payment_type: selected_payment}));
        }

        //
        window.scrollTo(0, 0);
    };

    PageOrderCheckout.prototype.__handleProceedPaymentError = function (res) {
        $.each(res.errors, function (i, error) {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-circle-x"></i>',
                header_title: $.sa.locales['error'] + ' ' + error.code,
                content: error.message,
                button_cancel_text: $.sa.locales['close']
            });
        });
    }

    PageOrderCheckout.prototype.togglePaymentFrame = function (show = true) {
        var that = this;

        that.$steps.toggleClass(that.class.hidden, show);
        that.$order_content.toggleClass(that.class.hidden, show);
        that.$order_sidebar.toggleClass(that.class.hidden, show);
        that.$flow_panel.toggleClass(that.class.hidden, show);
        that.$order_frame.toggleClass(that.class.hidden, !show);

        if (show) {
            $.sa.analytics.gtagSelectContent('page', 'main_payment');
        }
    }

    PageOrderCheckout.prototype.initPaymentStatusChecker = function () {
        var that = this,
            order_payment_status = null,
            href = $.sa.build_url('order/checkout/payment/status'),
            data = {
                order_hash: that.order_hash,
                order_passenger_hash: that.order_passenger_hash,
                order_payment_hash: that.order_payment_hash,
            };

        var success_statuses = [
                'paid',
                'issue_processing',
                'issue_processing_failure',
                'issued',
            ],
            fail_statuses = [
                'void',
                'canceled'
            ];

        var counter = 0,
            is_locked = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }

                if (!that.$order_frame.is(':visible')) {
                    clearInterval(timer);
                    if (window.removeEventListener) {
                        window.removeEventListener('message', that.dispatchEventMessage);
                    }
                    return;
                }

                if (counter >= 240) {
                    clearInterval(timer);
                    $.sa.content_router.load(that.order_url);
                } else {
                    is_locked = true;

                    $.post(href, data, function (res) {
                        $.sa.log('status_res', res);
                        $.sa.log('that.order_checkout_result_urls', that.order_checkout_result_urls);
                        if (res && res.data) {
                            if (res.data.status) {
                                order_payment_status = res.data.status;
                            }

                            if (res.data.status === false) {
                                clearInterval(timer);
                                window.location.reload();
                            }
                        }

                        if ($.inArray(order_payment_status, success_statuses) !== -1) {
                            clearInterval(timer);
                            if (order_payment_status === 'issue_processing_failure') {
                                $.sa.content_router.load(that.order_checkout_result_urls['fail']);
                            } else if (window.location.href !== that.order_checkout_result_urls['success']) {
                                if (that.analytics_data && that.analytics_select_content_id[that.analytics_data.layout]) {
                                    // TODO: fix content_id for svc_add and exchange
                                    $.sa.analytics.gtagSelectContent('page', 'main_processing');
                                }
                                $.sa.content_router.load(that.order_checkout_result_urls['success']);
                            }
                        } else if ($.inArray(order_payment_status, fail_statuses) !== -1) {
                            clearInterval(timer);
                            $.sa.content_router.load(that.order_checkout_result_urls['fail']);
                        }
                        is_locked = false;
                    });
                    counter++;
                }
            }, 2500);
    };

    PageOrderCheckout.prototype.constructEventListener = function () {
        var that = this;

        if (window.addEventListener) {
            window.addEventListener('message', that.dispatchEventMessage, false);
        } else {
            console.log('postMessages not supported: https://developer.mozilla.org/ru/docs/Web/API/Window/postMessage');
        }
    };

    PageOrderCheckout.prototype.dispatchEventMessage = function (event) {
        var that = this,
            data = event.data;
        if (!data.length) {
            return false;
        }
        if (typeof event.data === 'string') {
            data = JSON.parse(event.data);
        }

        if (data.message_source && data.message_source === 'avia') {
            $.sa.log('Avia app event', data);
        } else {
            return false;
        }

        switch (data.type) {
            case 'retry_checkout':
                if (window.removeEventListener) {
                    window.removeEventListener('message', that.dispatchEventMessage);
                }
                window.location.reload();
                break;
        }
    };

    PageOrderCheckout.prototype.initOrderWillBeCanceledModal = function () {
        var that = this;

        that.$wrapper.on('click', '.js-order-will-be-canceled', function (event) {
            event.preventDefault();

            var $link = $(this),
                href = $link.attr('href');

            $.sa.confirm.show({
                class_header: 'align-center',
                class_content: 'align-center',
                class_buttons: 'flex-center',
                icons: that.locales['order']['cancel']['icons'],
                title: that.locales['order']['cancel']['title'],
                content: that.locales['order']['cancel']['content'],
                onConfirm: function () {
                    if (typeof that.analytics_data === 'object') {
                        var selected_payment = that.$wrapper.find(`.${that.class.payment_selected}`).val();
                        $.sa.analytics.gtag('event', 'remove_from_cart', Object.assign({}, that.analytics_data, {payment_type: selected_payment}));
                    }
                    $.post(that.urls['booking_cancel'], {order_hash: that.order_hash});
                    $.sa.content_router.load(href);
                }
            });
        });
    };

    PageOrderCheckout.prototype.initFlowPanelMobileToggleEvents = function () {
        var that = this,
            $toggle_trigger_open = that.$flow_panel.find('.' + that.class.toggle_trigger_open),
            $toggle_trigger_close = that.$flow_panel.find('.' + that.class.toggle_trigger_close),
            $toggle_wrapper = that.$flow_panel.find('.' + that.class.toggle_wrapper);

        $toggle_trigger_open.on('click', function (event) {
            event.preventDefault();
            $toggle_wrapper.removeClass(that.class.closed);
        });

        $toggle_trigger_close.on('click', function (event) {
            event.preventDefault();
            $toggle_wrapper.addClass(that.class.closed);
        });
    };

    PageOrderCheckout.prototype.__sendBeginCheckoutAnalyticsEvent = function () {
        var that = this;
        if (that.analytics_data) {
            $.sa.analytics.gtag('event', 'begin_checkout', that.analytics_data);
        }
        if (that.flocktory_data) {
            $.sa.flocktory.push(['addToCart', that.flocktory_data]);
        }
    }

    PageOrderCheckout.prototype.__showOrderContactDataModal = function () {
        var that = this;

        that.order_contact_data_form = new OrderContactDataForm({
            modal: that.modals['order_contact_data'],
            onClose: function (is_valid, order_contact_data) {
                if (is_valid) {
                    that.order_contact_data = order_contact_data;
                }
            }
        });
    };

    PageOrderCheckout.prototype.__getConfirmTooltipContainer = function () {
        var that = this;

        return $.sa.is_desktop() ? that.$order_sidebar : that.$flow_panel;
    };

    PageOrderCheckout.prototype.__initPaymentInstancesAllButtonHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.payment_instances_all_button);

        $action.on('click', function () {
            that.__workupPaymentInstanceSelect();
        });
    };

    PageOrderCheckout.prototype.__workupPaymentInstanceSelect = function () {
        var that = this,
            $payment_instances_wrapper = that.$wrapper.find('.' + that.class.payment_instances_wrapper),
            selected_payment_id = $payment_instances_wrapper.find('.' + that.class.payment_instance + ' input:checked').val(),
            $cloned_payment_instances_wrapper = $payment_instances_wrapper.clone(true),

            onBeforeOpen = function () {
                $cloned_payment_instances_wrapper.find('.' + that.class.payment_instances_all_button_wrapper).remove();
                $cloned_payment_instances_wrapper.find('.' + that.class.payment_instance + ' input').attr('name', 'payment_temp').removeAttr('checked');
                $cloned_payment_instances_wrapper.find('.' + that.class.payment_instance + '[data-payment-id="' + selected_payment_id + '"] input').attr('checked', 'checked');
                var $cloned_payment_instances = $cloned_payment_instances_wrapper.find('.' + that.class.payment_instance);
                that.__workupPaymentInstances($cloned_payment_instances, false);
            },
            onOpen = function ($modal_wrapper) {
                $modal_wrapper.find('.modal-footer .button').addClass('full');
            },
            onConfirmClosed = function ($modal_wrapper) {
                selected_payment_id = $modal_wrapper.find('.' + that.class.payment_instance + ' input:checked').val();

                var $payment_instances = $payment_instances_wrapper.find('.' + that.class.payment_instance),
                    $selected_payment_instance = $payment_instances.filter('.' + that.class.payment_instance + '[data-payment-id="' + selected_payment_id + '"]');

                $selected_payment_instance.find('input').prop('checked', true)
                // Move selected variant into top
                $payment_instances_wrapper.prepend($selected_payment_instance);
                // update after prepend
                $payment_instances = $payment_instances_wrapper.find('.' + that.class.payment_instance);
                that.__workupPaymentInstances($payment_instances, true);
            };

        onBeforeOpen();

        $.uiModal({
            content: $cloned_payment_instances_wrapper.html(),
            mobile_fullscreen: true,
            custom_class: 'payment-select-modal',
            header_title: that.locales['payment_instances_select']['title'],
            button_confirm_text: $.sa.locales['select'],
            onOpen: function ($modal_wrapper) {
                onOpen($modal_wrapper);
            },
            onConfirmClosed: function (modal) {
                onConfirmClosed(modal.$wrapper);
            }
        });
    };

    PageOrderCheckout.prototype.__actualizeAvailablePaymentInstancesList = function (payment_instances) {
        var that = this,
            $payment_instances = that.$wrapper.find('.' + that.class.payment_instance),
            $selected_payment_instance = null;

        $payment_instances.each(function() {
            var $payment_instance = $(this),
                payment_id = $payment_instance.data('payment-id'),
                checked = $payment_instance.find('input').prop('checked'),
                is_available = !payment_instances
                    ? $payment_instance.data('available')
                    : payment_instances.indexOf(payment_id) >= 0;

            $payment_instance.data('available', is_available);
            if (is_available) {
                if (checked || ($selected_payment_instance === null)) {
                    // find first or checked available payment instance
                    $selected_payment_instance = $payment_instance;
                }
            } else if (checked) {
                $payment_instance.find('input').removeAttr('checked');
            }
        });

        // Move selected variant into top
        if ($selected_payment_instance) {
            $selected_payment_instance.find('input').prop('checked', true);
            var $payment_instances_wrapper = that.$wrapper.find('.' + that.class.payment_instances_wrapper);
            $payment_instances_wrapper.prepend($selected_payment_instance);
            $payment_instances = that.$wrapper.find('.' + that.class.payment_instance);
        }

        // Check that there are selected payment options
        that.__workupPaymentInstances(
            $payment_instances,
            true
        );
    };

    PageOrderCheckout.prototype.__workupPaymentInstances = function (
        $payment_instances,
        with_limit = false
    ) {
        var that = this,
            $payment_instances_wrapper = $payment_instances.parent(),
            count = 0;

        $payment_instances.each(function () {
            var $payment_instance = $(this),
                $payment_instance_input = $payment_instance.find('input');

            if (!!$payment_instance.data('available')) {
                count += 1;

                $payment_instance_input.removeAttr('disabled');

                if (with_limit && that.payment_instances_default_count_limit && that.payment_instances_default_count_limit < count) {
                    // hide items in cut
                    $payment_instance.hide();
                } else {
                    $payment_instance.show();
                }
            } else {
                $payment_instance_input.attr('disabled', 'disabled');
                $payment_instance.hide();
            }
        });

        if (with_limit) {
            var $payment_instances_all_button_wrapper = $payment_instances_wrapper.find('.' + that.class.payment_instances_all_button_wrapper);

            if (that.payment_instances_default_count_limit && that.payment_instances_default_count_limit < count) {
                $payment_instances_all_button_wrapper.show();
            } else {
                $payment_instances_all_button_wrapper.hide();
            }
        }
    };

    return PageOrderCheckout;
})($);
